import { Typography } from '@mui/material'
import React from 'react'

export default function ShowAllSevices({ onClose,
    selectedSevices,}) {
  return (
    <Typography variant='h6'>{selectedSevices.map((item) => item.name).join(",  ")}</Typography>
  )
}
